import * as React from 'react'
import { notification } from 'antd'

export const simpleNotification = (
    method: 'warning' | 'error' | 'success',
    description: React.ReactNode,
    duration?: number,
    key?: string,
    clear: boolean = false,
) => {
    if (clear) {
        notification.destroy()
    }

    notification[method]({
        key,
        className: 'simple-notification',
        message: undefined,
        description,
        duration,
    })
}

export const simpleFormErrorNotification = (error: any) => {
    const errors: string[] = []

    Object.keys(error).forEach((key) => {
        if (error[key].errors) {
            error[key].errors.forEach((err: any) => errors.push(err.message))
        }
    })

    simpleNotification(
        'error',
        errors.map((err: string) => <div key={err}>{err}</div>),
    )
}

// handle new Antd Form validation pattern introduced in Antd 4.x
export const handleFormErrorFields = (error: { values: any; errorFields: any[]; _outOfDate: boolean }) => {
    const errors: string[] = []

    error.errorFields.forEach((err) => {
        errors.push(err.errors)
    })

    simpleNotification(
        'error',
        errors.map((err: string) => <div key={err}>{err}</div>),
    )
}
